import styled from 'styled-components/macro';
import { HeadingLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const OrderPriceStyled = styled(HeadingLevel3) `
  ${getTextStyles('Play', 700, 24, 28)}
`;
